import { Component, OnInit, Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LanguageSelectionComponent } from 'src/app/components/language-selection/language-selection.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ProfileService } from 'src/app/shared/services/profile.service';

@Component({
  selector: 'app-standard',
  templateUrl: './standard.component.html',
  styleUrls: ['./standard.component.scss']
})

@Injectable()
export class StandardComponent implements OnInit {
  avatar: string = './assets/image/profile.svg'
  username: string = ""
  downloadURL: any;
  constructor(private profileService: ProfileService, private auth: AuthService, private storage: AngularFireStorage, private matDialog: MatDialog, private router: Router) { }


  logout() {
    this.auth.SignOut();
  }

  

  selectLanguage(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component";

    this.matDialog.open(LanguageSelectionComponent, dialogConfig);
  }

  ngOnInit(): void {
    this.profileService.getUserProfile().subscribe((user: any) => {
      if(localStorage.getItem("avatar") != './assets/image/profile.svg'){
        localStorage.setItem('avatar', this.avatar)
        const ref = this.storage.ref(`profiles/${user.payload.data().uid}`);
        this.downloadURL = ref.getDownloadURL().subscribe((res) => {
          this.avatar = res;
          localStorage.setItem('avatar', this.avatar)
        })
      }
      if(user.payload.data().firstName || user.payload.data().lastName){
        this.username = user.payload.data().firstName + ' ' + user.payload.data().lastName.charAt(0);
      }
      
      if(!user.payload.data().updated && !user.payload.data().wizard_completed){
        this.router.navigateByUrl('/wizard');
      }
   }, err => window.alert(err))
  }

}
